import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input, Spinner } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MdDone, MdWarning, MdCancel, MdEmail, MdCameraAlt } from 'react-icons/md'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'
import { CSVLink } from 'react-csv'
import Select from 'react-select'

const tbcolumn = [
  {
    label: 'Invoice No.',
    field: 'invoice_no',
    sort: 'asc',
  },
  {
    label: 'Customer',
    field: 'customer',
    sort: 'asc',
  },
  {
    label: 'Invoice Date',
    field: 'invoice_date',
    sort: 'asc',
  },
  {
    label: 'Due Date',
    field: 'due_date',
    sort: 'asc',
  },
  {
    label: 'Terms',
    field: 'terms',
    sort: 'asc',
  },
  {
    label: 'Location',
    field: 'location',
    sort: 'asc',
  },
  {
    label: 'Schedule',
    field: 'schedule',
    sort: 'asc',
  },
  {
    label: 'Memo',
    field: 'memo',
    sort: 'asc',
  },
  {
    label: 'Item(Product/Service)',
    field: 'item',
    sort: 'asc',
  },
  {
    label: 'Item(Description)',
    field: 'item_description',
    sort: 'asc',
  },
  {
    label: 'Item(Quantity)',
    field: 'item_quantity',
    sort: 'asc',
  },
  {
    label: 'Item(Rate)',
    field: 'item_rate',
    sort: 'asc',
  },
  {
    label: 'Item(Amount)',
    field: 'item_amount',
    sort: 'asc',
  },
  {
    label: 'Item(TaxCode)',
    field: 'item_taxcode',
    sort: 'asc',
  },
  {
    label: 'Item(TaxAmount)',
    field: 'item_taxamount',
    sort: 'asc',
  },
  {
    label: 'Currency',
    field: 'currency',
    sort: 'asc',
  },
  {
    label: 'Service Date',
    field: 'service_date',
    sort: 'asc',
  },
]

const headers = [
  {
    label: '*Invoice No.',
    key: 'invoice_no',
  },
  {
    label: '*Customer',
    key: 'customer',
  },
  {
    label: '*Invoice Date',
    key: 'invoice_date',
  },
  {
    label: '*Due Date',
    key: 'due_date',
  },
  {
    label: 'Terms',
    key: 'terms',
  },
  {
    label: 'Location',
    key: 'location',
  },
  {
    label: 'Schedule',
    key: 'schedule',
  },
  {
    label: 'Memo',
    key: 'memo',
  },
  {
    label: 'Item(Product/Service)',
    key: 'item',
  },
  {
    label: 'Item(Description)',
    key: 'item_description',
  },
  {
    label: 'Item(Quantity)',
    key: 'item_quantity',
  },
  {
    label: 'Item(Rate)',
    key: 'item_rate',
  },
  {
    label: '*Item(Amount)',
    key: 'item_amount',
  },
  {
    label: '*Item(TaxCode)',
    key: 'item_taxcode',
  },
  {
    label: 'Item(TaxAmount)',
    key: 'item_taxamount',
  },
  {
    label: 'Currency',
    key: 'currency',
  },
  {
    label: 'Service Date',
    key: 'service_date',
  },
]

class JianBoExportOrder extends React.Component {
  _isMounted = true
  JBExportOrder = StorageService.getSession('JBExportOrder')
  comp = StorageService.getSession('selected_org')
  constructor(props) {
    super(props)
    this.state = {
      //isLoading: true,
      filterList: [],
      // date:
      //   this.orderDetail && this.orderDetail.date
      //     ? this.orderDetail.date
      //     : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      fm_date: this.JBExportOrder && this.JBExportOrder.fm_date ? this.JBExportOrder.fm_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      to_date: this.JBExportOrder && this.JBExportOrder.to_date ? this.JBExportOrder.to_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),

      p_fm_date: this.JBExportOrder && this.JBExportOrder.p_fm_date ? this.JBExportOrder.p_fm_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      p_to_date: this.JBExportOrder && this.JBExportOrder.p_to_date ? this.JBExportOrder.p_to_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      f_fm_date: this.JBExportOrder && this.JBExportOrder.f_fm_date ? this.JBExportOrder.f_fm_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      f_to_date: this.JBExportOrder && this.JBExportOrder.f_to_date ? this.JBExportOrder.f_to_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      s_fm_date: this.JBExportOrder && this.JBExportOrder.s_fm_date ? this.JBExportOrder.s_fm_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      s_to_date: this.JBExportOrder && this.JBExportOrder.s_to_date ? this.JBExportOrder.s_to_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      i_fm_date: this.JBExportOrder && this.JBExportOrder.i_fm_date ? this.JBExportOrder.i_fm_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      ieat_fm_date: this.JBExportOrder && this.JBExportOrder.i_fm_date ? this.JBExportOrder.i_fm_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      iatasco_fm_date: this.JBExportOrder && this.JBExportOrder.i_fm_date ? this.JBExportOrder.i_fm_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      i_to_date: this.JBExportOrder && this.JBExportOrder.i_to_date ? this.JBExportOrder.i_to_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      ieat_to_date: this.JBExportOrder && this.JBExportOrder.i_to_date ? this.JBExportOrder.i_to_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      iatasco_to_date: this.JBExportOrder && this.JBExportOrder.i_to_date ? this.JBExportOrder.i_to_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      csvInvoice: [],
      csvPrepaid: [],
      csvFOC: [],
      storeList: [],
      store_id: this.JBExportOrder && this.JBExportOrder.store_id ? this.JBExportOrder.store_id : this.props.match.params.id,
      p_store_id: this.JBExportOrder && this.JBExportOrder.p_store_id ? this.JBExportOrder.p_store_id : this.props.match.params.id,
      f_store_id: this.JBExportOrder && this.JBExportOrder.f_store_id ? this.JBExportOrder.f_store_id : this.props.match.params.id,
      s_store_id: this.JBExportOrder && this.JBExportOrder.s_store_id ? this.JBExportOrder.s_store_id : this.props.match.params.id,
      i_store_id: this.JBExportOrder && this.JBExportOrder.i_store_id ? this.JBExportOrder.i_store_id : this.props.match.params.id,
      ieat_store_id: this.JBExportOrder && this.JBExportOrder.ieat_store_id ? this.JBExportOrder.ieat_store_id : this.props.match.params.id,
      iatasco_store_id: this.JBExportOrder && this.JBExportOrder.iatasco_store_id ? this.JBExportOrder.iatasco_store_id : this.props.match.params.id,
      supplierList: [],
      supplier_id: this.JBExportOrder && this.JBExportOrder.supplier_id ? this.JBExportOrder.supplier_id : 'All',
      p_supplier_id: this.JBExportOrder && this.JBExportOrder.p_supplier_id ? this.JBExportOrder.p_supplier_id : '',
      Role: this.comp.Role,
      consolidate: this.JBExportOrder && this.JBExportOrder.consolidate ? this.JBExportOrder.consolidate : 0,
      headers: [],
      userList: [],
      user_id: '',
      outlet_order: [],
      sales_report: [],
      listPdf:[]
    }

    this.csvLinkEl = React.createRef()
    this.csvLinkEl2 = React.createRef()
    this.csvLinkEl3 = React.createRef()
    this.csvLinkEl4 = React.createRef()
    this.csvLinkEl5 = React.createRef()
    this.csvLinkEl6 = React.createRef()
    this.csvLinkEl7 = React.createRef()
  }

  componentDidMount() {
    //this.getOrder();
    // this.CsvInvoice();
    // this.CsvPrepaid();
    // this.CsvFOC();
    this.getStoreList()
    this.getSupplier()
    this.getUserList()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getUserList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3000/v1/users', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.setState({ userList: result.data })
      })
      .catch(error => {
        alert(error)
      })
  }

  getStoreList() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          let storeList = []
          for (let i of access.store) {
            for (let j of result.data) {
              if (j.store_id === i.store_id) {
                if (i.role == 'Admin' || i.role == 'Supervisor' || i.role == 'Financial' || i.role == 'Manager' || i.role == 'Superuser') {
                  storeList.push(j)
                }
              }
            }
          }
          this.setState({
            storeList: storeList,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getSupplier = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3002/v1/product/supplier', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            supplierList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data[name] = value
    StorageService.setSession('JBExportOrder', data)
    this.JBExportOrder = StorageService.getSession('JBExportOrder')
  }

  storeHandler = e => {
    const { label, value } = e
    this.setState({
      store_id: value,
    })
    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data['store_id'] = value
    StorageService.setSession('JBExportOrder', data)
    this.JBExportOrder = StorageService.getSession('JBExportOrder')
  }

  p_storeHandler = e => {
    const { label, value } = e
    this.setState({
      p_store_id: value,
    })
    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data['p_store_id'] = value
    StorageService.setSession('JBExportOrder', data)
    this.JBExportOrder = StorageService.getSession('JBExportOrder')
  }

  f_storeHandler = e => {
    const { label, value } = e
    this.setState({
      f_store_id: value,
    })
    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data['f_store_id'] = value
    StorageService.setSession('JBExportOrder', data)
    this.JBExportOrder = StorageService.getSession('JBExportOrder')
  }

  s_storeHandler = e => {
    const { label, value } = e
    this.setState({
      s_store_id: value,
    })
    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data['s_store_id'] = value
    StorageService.setSession('JBExportOrder', data)
    this.JBExportOrder = StorageService.getSession('JBExportOrder')
  }

  i_storeHandler = e => {
    const { label, value } = e
    this.setState({
      i_store_id: value,
    })
    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data['i_store_id'] = value
    StorageService.setSession('JBExportOrder', data)
    this.JBExportOrder = StorageService.getSession('JBExportOrder')
  }

  ieat_storeHandler = e => {
    const { label, value } = e
    this.setState({
      ieat_store_id: value,
    })
    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data['ieat_store_id'] = value
    StorageService.setSession('JBExportOrder', data)
    this.JBExportOrder = StorageService.getSession('JBExportOrder')
  }

  iatasco_storeHandler = e => {
    const { label, value } = e
    this.setState({
      iatasco_store_id: value,
    })
    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data['iatasco_store_id'] = value
    StorageService.setSession('JBExportOrder', data)
    this.JBExportOrder = StorageService.getSession('JBExportOrder')
  }

  changeHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data[name] = value
    StorageService.setSession('JBExportOrder', data)
    //this.getOrder(value)
  }

  searchHandler = e => {
    console.log(e.target)
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })

    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data[name] = value
    StorageService.setSession('JBExportOrder', data)
    this.JBExportOrder = StorageService.getSession('JBExportOrder')
  }

  dateHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })

    let data = this.JBExportOrder ? this.JBExportOrder : {}
    data[name] = value
    StorageService.setSession('JBExportOrder', data)
    this.JBExportOrder = StorageService.getSession('JBExportOrder')

    if (name === 'fm_date') {
      this.setState({
        to_date: value,
      })
      let data = this.JBExportOrder ? this.JBExportOrder : {}
      data['to_date'] = value
      StorageService.setSession('JBExportOrder', data)
      this.JBExportOrder = StorageService.getSession('JBExportOrder')
    }

    if (name === 'p_fm_date') {
      this.setState({
        p_to_date: value,
      })
      let data = this.JBExportOrder ? this.JBExportOrder : {}
      data['p_to_date'] = value
      StorageService.setSession('JBExportOrder', data)
      this.JBExportOrder = StorageService.getSession('JBExportOrder')
    }

    if (name === 'f_fm_date') {
      this.setState({
        f_to_date: value,
      })
      let data = this.JBExportOrder ? this.JBExportOrder : {}
      data['f_to_date'] = value
      StorageService.setSession('JBExportOrder', data)
      this.JBExportOrder = StorageService.getSession('JBExportOrder')
    }

    if (name === 's_fm_date') {
      this.setState({
        s_to_date: value,
      })
      let data = this.JBExportOrder ? this.JBExportOrder : {}
      data['s_to_date'] = value
      StorageService.setSession('JBExportOrder', data)
      this.JBExportOrder = StorageService.getSession('JBExportOrder')
    }

    if (name === 'i_fm_date') {
      this.setState({
        i_to_date: value,
      })
      let data = this.JBExportOrder ? this.JBExportOrder : {}
      data['s_to_date'] = value
      StorageService.setSession('JBExportOrder', data)
      this.JBExportOrder = StorageService.getSession('JBExportOrder')
    }
  }

  CsvInvoice = async () => {
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      //store_id: '271',
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
      supplier_id: this.state.supplier_id,
      consolidate: this.state.consolidate,
    }

    axios
      .post(url + ':3003/v1/order/export/custom/jb', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.invoice_date) {
              i.invoice_date = moment(i.invoice_date).tz('Asia/Singapore').format('DD/MM/YYYY')
            }
          }

          if (result.data.length > 0) {
            let headers = [
              ...Object.keys(result.data[0])
                .reduce((r, o) => {
                  let key = o
                  let item = { key: o, label: o }
                  return r.set(key, item)
                }, new Map())
                .values(),
            ]

            this.setState(
              {
                csvInvoice: result.data,
                isLoading: false,
                headers: headers,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound('No Orders for Supplier')
          }
        }
      })
      .catch(error => {
        alert(error)
        this.setState({
          isLoading: false,
        })
      })
  }

  async ExportAllSupplierOrder(supplier_id, supplier_name) {
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    let fm_date = this.state.p_fm_date
    let to_date = this.state.p_to_date
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.p_store_id,
      //store_id: 271,
      fm_date: fm_date,
      to_date: to_date,
      supplier_id: supplier_id,
      fulfilment_date: this.state.p_fm_date
      //supplier_id: 'ygZWhhMmvrI4vVA7zyHI',
    }
    console.log(data)

    axios
      .post(url + ':3003/v1/order/export/custom/jb/pdf', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          //alert(result.message)

          this.CsvNotFound(result.message)
          return
        }
        if (this._isMounted) {
          window.open(`https://unityapi2.pseudoscops.com/topdfso.php?d=${result.data}`, '_blank')
          this.setState({ isLoading: false })
        }
      })
      .catch(error => {
        if (error == 'No Orders for Supplier') {
          this.CsvNotFound(error)
        } else {
          alert(error)
        }

        this.setState({
          isLoading: false,
        })
      })
  }

  async NewExportAllSupplierOrder(supplier_id, supplier_name) {
    this.setState({ isLoading: true });
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    let fm_date = this.state.p_fm_date;
    let to_date = this.state.p_to_date;
    const data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        store_id: this.state.p_store_id,
        fm_date: fm_date,
        to_date: to_date,
        supplier_id: supplier_id,
        fulfilment_date: this.state.p_fm_date,
    };
    console.log(data);

    try {
        const response = await axios.post(`${url}:3003/v1/order/export/custom/jb/pdf4`, data);
        const result = response.data;

        // Handle error case
        if (result.error === true && result.message !== 'Success') {
            this.CsvNotFound(result.message);
            return null; 
        }

        
        return result.data;

    } catch (error) {
        if (error.message === 'No Orders for Supplier') {
            this.CsvNotFound(error.message);
        } else {
            //alert(error.message);
        }
        return null; 
    } finally {
        this.setState({ isLoading: false });
    }
}
  
NewExportAll = async () => {
  const results = []; 
    const supplierList = this.state.supplierList;

    if (supplierList.length) {
        for (let supplier of supplierList) {
            const resultData = await this.NewExportAllSupplierOrder(supplier.id, supplier.name);
            if (resultData) {
                results.push(resultData); 
            }
        }
        console.log('All results:', results); 
        window.open(`https://unityapi2.pseudoscops.com:3051/v1/pdf/exportall/supplier?id=${results}`, '_blank')
    } else {
        this.CsvNotFound('No orders for supplier');
    }
}

  ExportAll = async () => {
    if (this.state.supplierList.length) {
      //console.log(this.state.supplierList);
      //var test = []
      for (let i of this.state.supplierList) {
        //test.push(i.id);
        //console.log(test);
        //this.NewExportAllSupplierOrder(i.id, i.name);
        this.ExportAllSupplierOrder(i.id, i.name);
      }
    } else {
      this.CsvNotFound('No orders for supplier')
    }
  }

  CsvPrepaid = event => {
    event.preventDefault()
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    let fm_date = this.state.p_fm_date
    let to_date = this.state.p_to_date
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.p_store_id,
      //store_id: 271,
      fm_date: fm_date,
      to_date: to_date,
      supplier_id: this.state.p_supplier_id,
      to_fulfilment_date: this.state.p_to_date,
      from_fulfilment_date: this.state.p_fm_date
      //supplier_id: 'ygZWhhMmvrI4vVA7zyHI',
    }

    axios
      .post(url + ':3003/v1/order/export/custom/jb/pdf4', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          //alert(result.message)

          this.CsvNotFound(result.message)
          return
        }
        if (this._isMounted) {
          setTimeout(() => {
            //window.open(`https://unityapi2.pseudoscops.com/topdfso_jb.php?d=${result.data}`, '_blank')
            window.open(`https://unityapi2.pseudoscops.com:3051/v1/pdf/export/supplier/${result.data}`, '_blank')
          }, 500)

          this.setState({ isLoading: false })
        }
      })
      .catch(error => {
        if (error == 'No Orders for Supplier') {
          this.CsvNotFound(error)
        } else {
          alert(error)
        }

        this.setState({
          isLoading: false,
        })
      })
  }

  OutletOrder = event => {
    event.preventDefault()
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    let fm_date = this.state.f_fm_date
    let to_date = this.state.f_to_date
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.f_store_id,
      //store_id: 271,
      fm_date: fm_date,
      to_date: to_date,
      user_id: this.state.user_id,
      //supplier_id: 'ygZWhhMmvrI4vVA7zyHI',
    }

    axios
      .post(url + ':3003/v2/order/export/custom/jb/customer', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          //alert(result.message)

          this.CsvNotFound(result.message)
          return
        }
        if (this._isMounted) {
          if (result.data.length > 0) {
            let headers = [
              ...Object.keys(result.data[0])
                .reduce((r, o) => {
                  console.log(o)
                  let key = o
                  let item = { key: o, label: o }
                  return r.set(key, item)
                }, new Map())
                .values(),
            ]

            this.setState(
              {
                outlet_order: result.data,
                isLoading: false,
                headers: headers,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl3.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound('No Orders for Outlet')
          }
        }
      })
      .catch(error => {
        if (error == 'No Orders for Outlet') {
          this.CsvNotFound(error)
        } else {
          alert(error)
        }

        this.setState({
          isLoading: false,
        })
      })
  }

  SalesReport = event => {
    event.preventDefault()
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.f_store_id,
      //store_id: 271,
      fm_date: this.state.s_fm_date,
      to_date: this.state.s_to_date,
    }

    axios
      .post(url + ':3003/v1/order/export/custom/jb/sales', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          //alert(result.message)

          this.CsvNotFound(result.message)
          return
        }
        if (this._isMounted) {
          if (result.data.length > 0) {
            let headers = [
              ...Object.keys(result.data[0])
                .reduce((r, o) => {
                  console.log(o)
                  let key = o
                  let item = { key: o, label: o }
                  return r.set(key, item)
                }, new Map())
                .values(),
            ]

            this.setState(
              {
                sales_report: result.data,
                isLoading: false,
                headers: headers,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl4.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound('No Orders for Outlet')
          }
        }
      })
      .catch(error => {
        if (error == 'No Orders for Outlet') {
          this.CsvNotFound(error)
        } else {
          alert(error)
        }

        this.setState({
          isLoading: false,
        })
      })
  }

  ExportInvoice = event => {
    event.preventDefault()
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.i_store_id,
      //store_id: 271,
      fm_date: this.state.i_fm_date,
      to_date: this.state.i_to_date,
    }

    axios
      .post(url + ':3003/v1/order/export/custom/jb/invoice', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          //alert(result.message)

          this.CsvNotFound(result.message)
          return
        }
        if (this._isMounted) {
          if (result.data.length > 0) {
            let headers = [
              ...Object.keys(result.data[0])
                .reduce((r, o) => {
                  console.log(o)
                  let key = o
                  let item = { key: o, label: o }
                  return r.set(key, item)
                }, new Map())
                .values(),
            ]

            this.setState(
              {
                sales_report: result.data,
                isLoading: false,
                headers: headers,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl5.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound('No Orders for Outlet')
          }
        }
      })
      .catch(error => {
        if (error == 'No Orders for Outlet') {
          this.CsvNotFound(error)
        } else {
          alert(error)
        }

        this.setState({
          isLoading: false,
        })
      })
  }

  ExportInvoiceEatAlley = event => {
    event.preventDefault()
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      //company_id: comp.CompanyID,
      store_id: this.state.ieat_store_id,
      //store_id: 271,
      fm_date: this.state.ieat_fm_date,
      to_date: this.state.ieat_to_date,
    }

    axios
      .post(url + ':3003/v1/order/export/custom/jb/invoice/eatalley', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          //alert(result.message)

          this.CsvNotFound(result.message)
          return
        }
        if (this._isMounted) {
          if (result.data.length > 0) {
            let headers = [
              ...Object.keys(result.data[0])
                .reduce((r, o) => {
                  console.log(o)
                  let key = o
                  let item = { key: o, label: o }
                  return r.set(key, item)
                }, new Map())
                .values(),
            ]

            this.setState(
              {
                sales_report: result.data,
                isLoading: false,
                headers: headers,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl6.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound('No Orders for Outlet')
          }
        }
      })
      .catch(error => {
        if (error == 'No Orders for Outlet') {
          this.CsvNotFound(error)
        } else {
          alert(error)
        }

        this.setState({
          isLoading: false,
        })
      })
  }

  ExportInvoiceAtasco = event => {
    event.preventDefault()
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      //company_id: comp.CompanyID,
      store_id: this.state.iatasco_store_id,
      //store_id: 271,
      fm_date: this.state.iatasco_fm_date,
      to_date: this.state.iatasco_to_date,
    }

    axios
      .post(url + ':3003/v1/order/export/custom/jb/invoice/atasco', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          //alert(result.message)

          this.CsvNotFound(result.message)
          return
        }
        if (this._isMounted) {
          if (result.data.length > 0) {
            let headers = [
              ...Object.keys(result.data[0])
                .reduce((r, o) => {
                  console.log(o)
                  let key = o
                  let item = { key: o, label: o }
                  return r.set(key, item)
                }, new Map())
                .values(),
            ]

            this.setState(
              {
                sales_report: result.data,
                isLoading: false,
                headers: headers,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl7.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound('No Orders for Outlet')
          }
        }
      })
      .catch(error => {
        if (error == 'No Orders for Outlet') {
          this.CsvNotFound(error)
        } else {
          alert(error)
        }

        this.setState({
          isLoading: false,
        })
      })
  }

  CsvNotFound(message) {
    this.setState({ isLoading: false })
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: message,
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  render() {
    const data = {
      columns: tbcolumn,
      rows: this.state.filterList,
    }

    let options = [
      ...this.state.storeList
        .reduce((r, o) => {
          let key = o.store_id
          let item = { value: o.store_id, label: o.name }
          return r.set(key, item)
        }, new Map())
        .values(),
    ]

    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <Form>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Supplier Order (CSV)</p>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Store</Label>
              <Select options={options} value={options.filter(i => i.value == this.state.store_id)} name="store_id" onChange={this.storeHandler} menuPosition={'fixed'} required />
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="fm_date" value={this.state.fm_date} onChange={this.dateHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Label></Label>
              <p
                style={{
                  padding: '0.4rem',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}>
                To
              </p>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="to_date" value={this.state.to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Label>Supplier</Label>
              <Input className="ps-input-small" type="select" name="supplier_id" value={this.state.supplier_id} onChange={this.changeHandler}>
                <option value="All">All</option>
                {this.state.supplierList.map(item => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  )
                })}
              </Input>
            </Col>
            <Col md={1}>
              <Label>Consolidate</Label>
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" name="consolidate" checked={this.state.consolidate} onChange={this.checkHandler} />
                </Label>
              </FormGroup>
            </Col>
            <Col
              md={1}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="button" className="ps-input-small theme-button-primary" disabled={this.state.isLoading} onClick={this.CsvInvoice}>
                Export
              </Button>
              <CSVLink headers={this.state.headers} filename={'supplier_order_' + moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.csvInvoice} ref={this.csvLinkEl} />
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
          </Row>
        </Form>

        <Form onSubmit={this.CsvPrepaid}>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Supplier Order (PDF)</p>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Store</Label>
              <Select options={options} value={options.filter(i => i.value == this.state.p_store_id)} name="p_store_id" onChange={this.p_storeHandler} menuPosition={'fixed'} required />
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="p_fm_date" value={this.state.p_fm_date} onChange={this.dateHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Label></Label>
              <p
                style={{
                  padding: '0.4rem',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}>
                To
              </p>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="p_to_date" value={this.state.p_to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Label>Supplier</Label>
              <Input className="ps-input-small" type="select" name="p_supplier_id" value={this.state.p_supplier_id} onChange={this.changeHandler} required>
                <option value=""></option>
                {this.state.supplierList.map(item => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  )
                })}
              </Input>
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
            <Col
              md={1}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="submit" className="ps-input-small theme-button-primary" disabled={this.state.isLoading}>
                Export
              </Button>
              {/* <CSVLink headers={headers} filename={'prepaid_invoice_' + moment(this.state.p_fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.p_to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.csvPrepaid} ref={this.csvLinkEl2} /> */}
            </Col>
            <Col
              md={1}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="button" className="ps-input-small theme-button-primary" disabled={this.state.isLoading} onClick={this.NewExportAll}>
                Export All
              </Button>
            </Col>
          </Row>
        </Form>

        <Form onSubmit={this.OutletOrder}>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Outlet Order (CSV)</p>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Store</Label>
              <Select options={options} value={options.filter(i => i.value == this.state.f_store_id)} name="f_store_id" onChange={this.f_storeHandler} menuPosition={'fixed'} required />
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="f_fm_date" value={this.state.f_fm_date} onChange={this.dateHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Label></Label>
              <p
                style={{
                  padding: '0.4rem',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}>
                To
              </p>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="f_to_date" value={this.state.f_to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Label>Outlet</Label>
              <Input className="ps-input-small" type="select" name="user_id" value={this.state.user_id} onChange={this.changeHandler} required>
                <option value=""></option>
                {this.state.userList.map(item => {
                  return (
                    <option key={item.user_id} value={item.user_id}>
                      {item.name}
                    </option>
                  )
                })}
              </Input>
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
            <Col
              md={1}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="submit" className="ps-input-small theme-button-primary" disabled={this.state.isLoading}>
                Export
              </Button>
              <CSVLink headers={this.state.headers} filename={'outlet_order_' + moment(this.state.f_fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.f_to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.outlet_order} ref={this.csvLinkEl3} />
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
          </Row>
        </Form>

        <Form onSubmit={this.SalesReport}>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Sales Report (CSV)</p>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Store</Label>
              <Select options={options} value={options.filter(i => i.value == this.state.s_store_id)} name="s_store_id" onChange={this.s_storeHandler} menuPosition={'fixed'} required />
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Order Date</Label>
                <Input className="ps-input-small" type="date" name="s_fm_date" value={this.state.s_fm_date} onChange={this.dateHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Label></Label>
              <p
                style={{
                  padding: '0.4rem',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}>
                To
              </p>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Order Date</Label>
                <Input className="ps-input-small" type="date" name="s_to_date" value={this.state.s_to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Label></Label>
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
            <Col
              md={1}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="submit" className="ps-input-small theme-button-primary" disabled={this.state.isLoading}>
                Export
              </Button>
              <CSVLink headers={this.state.headers} filename={'sales_report_' + moment(this.state.s_fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.s_to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.sales_report} ref={this.csvLinkEl4} />
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
          </Row>
        </Form>
        <Form onSubmit={this.ExportInvoice}>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Sales Invoice (CSV) - KOPITIAM</p>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Store</Label>
              <Select options={options} value={options.filter(i => i.value == this.state.i_store_id)} name="i_store_id" onChange={this.i_storeHandler} menuPosition={'fixed'} required />
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="i_fm_date" value={this.state.i_fm_date} onChange={this.dateHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Label></Label>
              <p
                style={{
                  padding: '0.4rem',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}>
                To
              </p>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="i_to_date" value={this.state.i_to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Label></Label>
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
            <Col
              md={1}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="submit" className="ps-input-small theme-button-primary" disabled={this.state.isLoading}>
                Export
              </Button>
              <CSVLink headers={this.state.headers} filename={'invoice_' + moment(this.state.i_fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.i_to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.sales_report} ref={this.csvLinkEl5} />
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
          </Row>
        </Form>
        <Form onSubmit={this.ExportInvoiceEatAlley}>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Sales Invoice (CSV) - EATALLEY</p>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Store</Label>
              <Select options={options} value={options.filter(i => i.value == this.state.ieat_store_id)} name="ieat_store_id" onChange={this.ieat_storeHandler} menuPosition={'fixed'} required />
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="ieat_fm_date" value={this.state.ieat_fm_date} onChange={this.dateHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Label></Label>
              <p
                style={{
                  padding: '0.4rem',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}>
                To
              </p>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="ieat_to_date" value={this.state.ieat_to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Label></Label>
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
            <Col
              md={1}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="submit" className="ps-input-small theme-button-primary" disabled={this.state.isLoading}>
                Export
              </Button>
              <CSVLink headers={this.state.headers} filename={'invoice_eatalley_' + moment(this.state.ieat_fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.ieat_to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.sales_report} ref={this.csvLinkEl6} />
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
          </Row>
        </Form>
        <Form onSubmit={this.ExportInvoiceAtasco}>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Sales Invoice (CSV) - ATASCO</p>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Store</Label>
              <Select options={options} value={options.filter(i => i.value == this.state.iatasco_store_id)} name="iatasco_store_id" onChange={this.iatasco_storeHandler} menuPosition={'fixed'} required />
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="iatasco_fm_date" value={this.state.iatasco_fm_date} onChange={this.dateHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Label></Label>
              <p
                style={{
                  padding: '0.4rem',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}>
                To
              </p>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="iatasco_to_date" value={this.state.iatasco_to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Label></Label>
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
            <Col
              md={1}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="submit" className="ps-input-small theme-button-primary" disabled={this.state.isLoading}>
                Export
              </Button>
              <CSVLink headers={this.state.headers} filename={'invoice_atasco_' + moment(this.state.iatasco_fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.iatasco_to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.sales_report} ref={this.csvLinkEl7} />
            </Col>
            <Col md={1}>
              <Label></Label>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export default JianBoExportOrder
